import { render, staticRenderFns } from "./NewCallFlow.vue?vue&type=template&id=2532f306&scoped=true&"
import script from "./NewCallFlow.vue?vue&type=script&lang=js&"
export * from "./NewCallFlow.vue?vue&type=script&lang=js&"
import style0 from "./NewCallFlow.vue?vue&type=style&index=0&id=2532f306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532f306",
  null
  
)

component.options.__file = "NewCallFlow.vue"
export default component.exports